export default __webpack_public_path__ + "static/media/lady-with-money-and-house.fda8194f.svg";